// TODO: P2: add report issues for popular articles
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
// import Menu from "@material-ui/core/Menu";
// import MenuItem from "@material-ui/core/MenuItem";
// import IconButton from "@material-ui/core/IconButton";
// import MoreVertIcon from "@material-ui/icons/MoreVert";
// import ReplayIcon from "@material-ui/icons/Replay";
// import ReportProblemIcon from "@material-ui/icons/ReportProblem";

import { Menu, MenuItem, IconButton, Tooltip } from '@mui/material';
import {
  MoreVert as MoreVertIcon,
  Replay as ReplayIcon,
  ReportProblem as ReportProblemIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  Download as DownloadIcon,
  Share as ShareIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';

import loadingIcon from '../../../Assets/loading.gif';
import {
  addArticleToUserPlaylist,
  getFeed,
} from '../../../audiblogsApi';
import userStore from '../../../Stores/User';
import { Modal } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import { isProPlan } from '../../../constants/plans';
import './PlaylistArticle.scss';
import Play from '../Icons/Play.svg';
import Pause from '../Icons/Pause.svg';
import ShareModal from '../../../Components/ShareModal/index';

// Cache for feed titles
const feedTitleCache = new Map();

const getHostName = (link) => {
  if (link) {
    const doc = document.createElement('a');
    doc.href = (link.startsWith('http') ? '' : 'http://') + link;
    return doc.hostname;
  }
};

const estimatedMinutes = async (audioUrl) => {
  if (!audioUrl) return 1;

  try {
    const audio = new Audio();
    audio.preload = 'metadata'; // Only load metadata, not the full audio
    
    return new Promise((resolve) => {
      const timeout = setTimeout(() => {
        audio.removeEventListener('loadedmetadata', handleMetadata);
        audio.removeEventListener('error', handleError);
        resolve(1);
      }, 5000); // 5 second timeout

      const handleMetadata = () => {
        clearTimeout(timeout);
        const minutes = Math.ceil(audio.duration / 60);
        resolve(Math.max(1, minutes));
      };

      const handleError = () => {
        clearTimeout(timeout);
        resolve(1);
      };

      audio.addEventListener('loadedmetadata', handleMetadata);
      audio.addEventListener('error', handleError);
      audio.src = audioUrl;
    });
  } catch (error) {
    console.error('Error getting audio duration:', error);
    return 1;
  }
};

const getMp3Prefix = (article) => {
  // console.log(article.audio_url)
  // Split by / and get the last part
  const prefix = article.audio_url.split("/").pop().replace(".mp3", "")
  // Get the last part of the url
  // const prefix = article.audio_url.split('/').slice(0, -1).join('/');
  try {
    return `/share/${prefix}`;
  } catch (e) {
    return `/404`;
  }
};

const PlaylistArticle = observer(
  ({
    article,
    trackingId,

    selectArticle,
    togglePlayed,
    removeArticle,
    isActive,
    showPlayedCheckbox,
  }) => {
    const [duration, setDuration] = useState(1);
    const { article_id, title, num_characters, thumbnail_url, voice_name, language } = article;
    const [isLoading, setIsLoading] = useState(false);
    const [menuAnchorEl, setAnchorEl] = useState(null);
    const [voiceAnchorEl, setVoiceAnchorEl] = useState(null);
    const [feedTitle, setFeedTitle] = useState(null);
    const [
      isModalOpen,
      { setTrue: showModal, setFalse: hideModal },
    ] = useBoolean(false);
    const [isShareModalOpen, setIsShareModalOpen] = useState(false);

    const isProUser = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id 
      ? isProPlan(userStore.user.subscriptions.raw_subscriptions[0].plan.id)
      : false;

    useEffect(() => {
      if (article.audio_url) {
        estimatedMinutes(article.audio_url)
          .then(mins => setDuration(mins))
          .catch(err => {
            console.error('Error getting duration:', err);
            setDuration(1);
          });
      }
    }, [article.audio_url]);

    useEffect(() => {
      if (article.feed_id) {
        // Check cache first
        const cachedTitle = feedTitleCache.get(article.feed_id);
        if (cachedTitle) {
          setFeedTitle(cachedTitle);
          return;
        }

        // If not in cache, fetch from backend
        getFeed(article.feed_id)
          .then(({ feed }) => {
            const title = feed.title;
            feedTitleCache.set(article.feed_id, title); // Store in cache
            setFeedTitle(title);
          })
          .catch(err => {
            console.error('Error fetching feed:', err);
          });
      }
    }, [article.feed_id]);

    const handleMenuClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
      setAnchorEl(null);
    };

    

    const reportArticleIssues = () => {
      handleMenuClose();
      window.open(
        `https://docs.google.com/forms/d/e/1FAIpQLSdgnJyc_F5xc2miuGnf8Y7epx8iZbXkRrUFbSsQVGMXHNcuWQ/viewform?usp=pp_url&entry.509739249=${encodeURIComponent(
          article.article_id
        )}&entry.188049192=${encodeURIComponent(userStore?.email || '')}`
      );
    };

    const downloadArticle = async () => {
      try {
        const response = await fetch(article.audio_url);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        const fileName = title.replace(/[^a-z0-9]/gi, '_').toLowerCase() + '.mp3';
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading article:', error);
      }
    };

    const shareArticle = () => {
      handleMenuClose();
      setIsShareModalOpen(true);
    };

    const deleteArticle = () => {
      handleMenuClose();
      removeArticle(article);
    };

    const toggledArticlePlayed = () => {
      handleMenuClose();
      togglePlayed(article);
    };

    const reDoArticle = async () => {
      handleMenuClose();
      setIsLoading(true);

      // Update the article status to 'in_progress'
      article.status = 'in_progress';

      try {
        // Assume addArticleToUserPlaylist returns a promise with the updated article
        const updatedArticle = await addArticleToUserPlaylist(
          article,
          userStore.idToken,
          '/playlist'
        );

        console.log('Updated article:', updatedArticle);

        // Optionally update the article with the response if needed
        // article.status = updatedArticle.status;
      } catch (error) {
        console.error('Error reprocessing article:', error);
      } finally {
        setIsLoading(false);
      }
    };

    return (
      <>
        <div className="playlist-article-card">
          <div className="article">
            <div className="context-menu">
              <IconButton onClick={handleMenuClick}>
                <MoreVertIcon htmlColor="#ffffff" />
              </IconButton>
              <Menu
                anchorEl={menuAnchorEl}
                keepMounted
                open={Boolean(menuAnchorEl)}
                onClose={handleMenuClose}
                style={{ zIndex: 1001 }}
              >
                <MenuItem onClick={toggledArticlePlayed}>
                  Mark As {article.played ? 'Unplayed' : 'Played'}
                </MenuItem>
                <MenuItem onClick={() => {
                  handleMenuClose();
                  window.open(`http://${article_id}`, '_blank');
                }}>
                  View Original Text
                </MenuItem>
                {article.status === 'completed' && (
                  <MenuItem onClick={reportArticleIssues}>
                    Report Issues
                  </MenuItem>
                )}
                <MenuItem onClick={deleteArticle}>Delete</MenuItem>
              </Menu>
            </div>
            <div
              className="thumbnail"
              onClick={() => {
                if (article.status !== 'failed') {
                  console.log('Selected article:', article);
                  selectArticle(article);
                }
              }}
              style={{ width: '40px' }}
            >
              {/* LazyLoad not working, something to do with the image already being loaded in the player below */}
              {thumbnail_url ? <img src={thumbnail_url} /> : null}
            </div>
            <div className="meta">
              <div className="play-button" onClick={() => {
                if (article.status !== 'failed') {
                  selectArticle(article);
                }
              }}>
                <Tooltip title={article.status === 'failed' ? "Conversion is taking longer than expected. We will email you when it is completed." : ""}>
                  <img src={isActive ? Pause : Play} alt={isActive ? "Pause" : "Play"} />
                </Tooltip>
              </div>
              <div className="content">
                <div
                  className="title"
                  onClick={() => {
                    if (article.status !== 'failed') {
                      console.log('Selected article:', article);
                      selectArticle(article);
                    }
                  }}
                  style={{
                    flex: 1,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    marginRight: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  {article.status === 'failed' ? (
                    <Tooltip title="Conversion is taking longer than expected. We will email you when it is completed.">
                      <span style={{ color: '#999' }}>
                        {title}
                      </span>
                    </Tooltip>
                  ) : (
                    <>
                      {showPlayedCheckbox && (
                        <CheckCircleIcon
                          style={{
                            color: article.played ? '#4292fa' : '#888',
                            fontSize: '16px',
                            flexShrink: 0,
                            opacity: article.played ? 1 : 0.4,
                          }}
                        />
                      )}
                      <span>{title}</span>
                    </>
                  )}
                </div>
                <div className="subtitle">
                  {article.status === 'completed' ? (
                    <div className="time">
                      {duration} min
                      <div className="voice-selector">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span className="voice-name">
                            {article.voice_name || article.voice || 'Not saved'}
                          </span>
                        </div>
                      </div>
                      <div className="action-icons">
                        {article.audio_url && (
                          <Tooltip title={isProUser ? "Download" : "Upgrade to Pro to download"}>
                            <DownloadIcon 
                              className="action-icon" 
                              onClick={async (e) => {
                                e.stopPropagation();
                                if (isProUser) {
                                  await downloadArticle();
                                } else {
                                  if (userStore.user?.customer_id) {
                                    window.location.href = userStore.customerPortalUrl;
                                  } else {
                                    window.location.href = '/onboarding/choosevoice';
                                  }
                                }
                              }}
                            />
                          </Tooltip>
                        )}
                        <Tooltip title="Share">
                          <ShareIcon 
                            className="action-icon"
                            onClick={(e) => {
                              e.stopPropagation();
                              shareArticle();
                            }}
                          />
                        </Tooltip>
                        {article.feed_id && (
                          <span style={{ 
                            color: 'rgba(255, 255, 255, 0.62)',
                            fontSize: '12px',
                            marginLeft: '8px'
                          }}>
                            {(feedTitle ? feedTitle.substring(0, 12) + (feedTitle.length > 12 ? '...' : '') : 'Loading...')}
                          </span>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="article-status">
                      {article.status === 'in_progress' ? (
                        <>
                          <img
                            src={loadingIcon}
                            style={{ height: 15, marginRight: '5px' }}
                          />
                          {article.status_details}
                        </>
                      ) : (
                        <div>
                          <button
                            style={{
                              backgroundColor: 'transparent',
                              color: 'rgba(255, 255, 255, 0.62)',
                              border: 'none',
                              display: 'flex',
                              alignItems: 'end',
                            }}
                            onClick={reDoArticle}
                          >
                            {isLoading ? (
                              <>
                                <img src={loadingIcon} style={{ height: '15px' }} />
                                <span style={{ marginLeft: '5px' }}>Requesting...</span>
                              </>
                            ) : (
                              <>
                                <ReplayIcon style={{ height: '15px' }} />{' '}
                                <span>Re-do</span>
                              </>
                            )}
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ShareModal 
          isOpen={isShareModalOpen}
          onClose={() => setIsShareModalOpen(false)}
          article={article}
        />
      </>
    );
  }
);

export default PlaylistArticle;
